/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { IColumn } from 'types'
import { format } from 'date-fns'
import { TrendingDown, TrendingUp } from '@mui/icons-material'
import InfoTooltip from 'components/atoms/buttons/InfoTooltip'
import { Button, Tooltip } from '@mui/material'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'redux/store'
import { FaEye } from 'react-icons/fa'
import { actionIcon, eyeIcon } from 'utils/customizedTheme'
import { setKpiStudent, setKpiSubject } from 'redux/ui/kpiEvaluationsUI'


const SCORE_COLORS = {
  "1": "red",
  "2": "#ffd853",
  "3": "#73d5a6"
}


export const useTableModel = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  
  const handleDateFormat = useCallback(
    (cellValue: string) => (cellValue ? format(new Date(cellValue), 'dd-MM-yyyy HH:ii') : ''),
    [],
  ) 

  const handleScoreFormat = (cellValue: any, row: any) => {

    let score = 3
    if(cellValue < 40){
      score = 2
    }
    if(cellValue < 80){
      score = 1
    }

    return <span style={{
        fontSize: '14px',
        fontWeight: 600,
      }}>{`${cellValue || '0'}%`}</span>
  }

  const handleTrendFormat = (cellValue: any, row: any) => {

    let score = 3
    if(row.growth_trend < 0){
      score = 2
    }
    if(row.growth_trend < -15){
      score = 1
    }

    return <span style={{ display: 'flex', gap: '5px', alignItems: 'center' }}><span style={{ 
        padding: '6px 14px',
        borderRadius: '10px',
        color: '#fff',
        textTransform: 'uppercase',
        fontSize: '14px',
        fontWeight: 600,
        backgroundColor: SCORE_COLORS[score],
      }}>{`${row.growth_trend}%`}</span> 
        {row.growth_trend > 0 && <TrendingUp sx={{ color: SCORE_COLORS["3"], fontSize: 30 }}/> }
        {row.growth_trend < 0 && <TrendingDown sx={{ color: SCORE_COLORS[score], fontSize: 30 }}/> }
      </span>
  }


  const handleScaffoldFormat = (cellValue: any, row: any) => {
    return <span>{row.scaffold_suggestion} {row.scaffold_explanation && <InfoTooltip hint={row.scaffold_explanation}></InfoTooltip>}</span> 
  }
  
  const handleActionsFormat = (cellValue: string, row: any) => 
          <Tooltip title={`${t('common.view')}`} arrow placement='top'>
            <Button
              onClick={() => {
                if(row.subject){
                  dispatch(setKpiStudent(row.student_id))
                  dispatch(setKpiSubject(row.subject))
                } 
              }}
              variant='outlined'
              color={'primary'}
              disableElevation
              sx={{ ...actionIcon, ...eyeIcon }}
            >
              <FaEye />
            </Button>
          </Tooltip>

  const columns: IColumn[] = [
    {
      title: `${t('common.student')}`,
      field: 'student',
      order: false,
      width: '20%',
    },
    {
      title: `${t('common.standard')}`,
      field: 'standard_code',
      order: false,
      width: '10%',
    },
    {
      title: `${t('common.assessed-on')}`,
      field: 'created_at',
      order: true,
      width: '10%',
      format: handleDateFormat,
    },
    {
      title: `${t('common.accuracy-rate')}`,
      field: 'accuracy_rate',
      order: true,
      width: '10%',
      format: handleScoreFormat,
    },
    {
      title: `${t('common.time-on-task')}`,
      field: 'time_on_task',
      order: true,
      width: '10%',
      format: handleScoreFormat,
    },
    {
      title: `${t('common.growth-trend')}`,
      field: 'growth_trend',
      order: true,
      width: '10%',
      format: handleTrendFormat,
    },
    {
      title: `${t('common.scaffold')}`,
      field: 'scaffold_suggestion',
      order: false,
      width: '26%',
      format: handleScaffoldFormat,
    },
    {
      title: '',
      field: '',
      width: '4%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}